import { Container} from './styles'

const Screen = () => {
  return (
    <Container/>
  )
}

export default Screen